/** Interactive workflow guides (Phase 3). */

export const WORKFLOWS = {
  affectation: {
    id: "affectation",
    route: "/affectations",
    steps: {
      fr: [
        {
          title: "1. Choisir la zone",
          body: "Sélectionnez la province, le département et la sous-préfecture. L'établissement se filtre automatiquement.",
        },
        {
          title: "2. Sélectionner l'établissement",
          body: "Choisissez l'établissement cible dans la liste déroulante.",
        },
        {
          title: "3. Choisir les enseignantes",
          body: "Cochez une ou plusieurs enseignantes à affecter. Utilisez la recherche si la liste est longue.",
        },
        {
          title: "4. Date et validation",
          body: "Indiquez la date d'affectation puis cliquez sur Enregistrer. Vérifiez le message de confirmation.",
        },
      ],
      en: [
        {
          title: "1. Choose the zone",
          body: "Select province, department, and sub-prefecture. Establishments filter automatically.",
        },
        {
          title: "2. Select establishment",
          body: "Pick the target establishment from the dropdown.",
        },
        {
          title: "3. Choose teachers",
          body: "Check one or more teachers to assign. Use search if the list is long.",
        },
        {
          title: "4. Date and save",
          body: "Set the assignment date and click Save. Confirm the success message.",
        },
      ],
    },
  },
  leave: {
    id: "leave",
    route: "/leave-requests",
    steps: {
      fr: [
        {
          title: "1. Ouvrir le formulaire",
          body: "Sur Demandes de congé, cliquez sur le bouton Ajouter pour ouvrir le dialogue.",
        },
        {
          title: "2. Enseignante et type",
          body: "Sélectionnez l'enseignante concernée et le type de congé (maladie, annuel, etc.).",
        },
        {
          title: "3. Dates",
          body: "Renseignez la date de début et de fin. Ajoutez un commentaire si nécessaire.",
        },
        {
          title: "4. Soumettre",
          body: "Validez la demande. Les administrateurs pourront approuver ou rejeter depuis la même page.",
        },
      ],
      en: [
        {
          title: "1. Open the form",
          body: "On Leave requests, click Add to open the dialog.",
        },
        {
          title: "2. Teacher and type",
          body: "Select the teacher and leave type (sick, annual, etc.).",
        },
        {
          title: "3. Dates",
          body: "Enter start and end dates. Add a comment if needed.",
        },
        {
          title: "4. Submit",
          body: "Submit the request. Admins can approve or reject from the same page.",
        },
      ],
    },
  },
  teacher: {
    id: "teacher",
    route: "/enseignantes",
    steps: {
      fr: [
        {
          title: "1. Accéder à l'annuaire",
          body: "Ouvrez Enseignantes depuis le menu latéral.",
        },
        {
          title: "2. Nouvelle fiche",
          body: "En haut de la page, cliquez sur + pour développer le formulaire « Ajouter un nouvel enseignant ».",
        },
        {
          title: "3. Informations",
          body: "Renseignez matricule, nom, prénoms, genre, diplôme, téléphone et e-mail.",
        },
        {
          title: "4. Recruteur (optionnel)",
          body: "Associez un recruteur si applicable, puis enregistrez.",
        },
      ],
      en: [
        {
          title: "1. Open directory",
          body: "Open Teachers from the sidebar.",
        },
        {
          title: "2. New record",
          body: "At the top of the page, click + to expand the « Add new teacher » form.",
        },
        {
          title: "3. Details",
          body: "Fill registration number, name, gender, degree, phone, and email.",
        },
        {
          title: "4. Recruiter (optional)",
          body: "Link a recruiter if applicable, then save.",
        },
      ],
    },
  },
  attendance: {
    id: "attendance",
    route: "/rapport-presence-etablissement",
    steps: {
      fr: [
        {
          title: "1. Filtrer la zone",
          body: "Sélectionnez province → département → sous-préfecture → établissement.",
        },
        {
          title: "2. Période",
          body: "Choisissez la date de début et de fin pour le rapport.",
        },
        {
          title: "3. Générer",
          body: "Lancez la recherche. Le tableau affiche les présences par jour.",
        },
        {
          title: "4. Synthèse zone",
          body: "Pour une vue agrégée, utilisez Synthèse présence zone.",
          altRoute: "/synthese-presence-zone",
        },
      ],
      en: [
        {
          title: "1. Filter zone",
          body: "Select province → department → sub-prefecture → establishment.",
        },
        {
          title: "2. Period",
          body: "Choose start and end dates for the report.",
        },
        {
          title: "3. Generate",
          body: "Run the search. The table shows daily attendance.",
        },
        {
          title: "4. Area summary",
          body: "For aggregated view, use Area attendance summary.",
          altRoute: "/synthese-presence-zone",
        },
      ],
    },
  },
};

export function getWorkflow(id, language) {
  const wf = WORKFLOWS[id];
  if (!wf) return null;
  const steps = wf.steps[language] || wf.steps.fr;
  return { ...wf, steps };
}

export function getWorkflowStep(workflowId, stepIndex, language) {
  const wf = getWorkflow(idOrWorkflow(workflowId), language);
  if (!wf) return null;
  const step = wf.steps[stepIndex];
  if (!step) return null;
  return {
    workflowId: wf.id,
    stepIndex,
    totalSteps: wf.steps.length,
    route: wf.route,
    altRoute: step.altRoute,
    title: step.title,
    body: step.body,
  };
}

function idOrWorkflow(id) {
  return id;
}

export function startWorkflow(id, language) {
  return getWorkflowStep(id, 0, language);
}

export function nextWorkflowStep(workflowId, currentIndex, language) {
  const wf = getWorkflow(idOrWorkflow(workflowId), language);
  if (!wf) return null;
  const next = currentIndex + 1;
  if (next >= wf.steps.length) {
    return { completed: true, workflowId: wf.id, route: wf.route };
  }
  return getWorkflowStep(workflowId, next, language);
}
